export const platformName = (platform) => ({ facebook: "Meta", tiktok: "TikTok", applovin: "AppLovin" }[platform] || platform);
export const pixelKey = (pixel) => `${pixel.platform}:${pixel.id}`;
export const pixelName = (pixel) => pixel?.name || (pixel ? `${platformName(pixel.platform)} · ${String(pixel.pixel_id).slice(-4)}` : "Unavailable pixel");

export function pixelValidationError(pixel) {
  if (pixel.platform === "applovin") {
    if (/^[*•●\s]+$/u.test(pixel.access_token.trim())) return "Enter a Conversion API key, not a masked placeholder.";
    if (!/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(pixel.pixel_id.trim())) return "Enter a valid AppLovin Event Key (UUID).";
    if (![0, 1].includes(Number(pixel.tracking_owner))) return "Choose who sends storefront events.";
    const mappings = normalizeVendorCategoryMappings(pixel.vendor_category_mappings);
    if (mappings.length > 100) return "Add no more than 100 vendor mappings.";
    const vendors = new Set();
    for (const mapping of mappings) {
      if (!mapping.vendor || mapping.applovin_category_id === '') return "Enter both a vendor and an AppLovin category ID for each mapping.";
      if (Array.from(mapping.vendor).length > 255) return "Vendor must be 255 characters or fewer.";
      if (!/^[0-9]+$/.test(String(mapping.applovin_category_id)) || Number(mapping.applovin_category_id) < 1 || Number(mapping.applovin_category_id) > 2147483647) return "Enter an AppLovin category ID from 1 to 2147483647.";
      if (vendors.has(mapping.vendor)) return "Each vendor can have only one category mapping.";
      vendors.add(mapping.vendor);
    }
  } else if (!pixel.pixel_id.trim() || (!pixel.has_access_token && !pixel.access_token.trim())) {
    return "Enter a Pixel ID and an access token.";
  }
  return "";
}

export function normalizeVendorCategoryMappings(mappings = []) {
  return mappings.map(({ vendor, applovin_category_id }) => ({
    vendor: String(vendor ?? '').trim(),
    applovin_category_id: String(applovin_category_id ?? '').trim(),
  })).filter((mapping) => mapping.vendor || mapping.applovin_category_id);
}

export function normalizeProductId(value) {
  const match = String(value || "").trim().match(/^(?:gid:\/\/shopify\/Product\/)?(\d{1,32})$/);
  return match ? match[1].replace(/^0+/, "") : "";
}

export function pixelResponse(response) {
  if (Number(response?.status) !== 200 || !response?.data) {
    const error = new Error(response?.msg || "The request could not be completed. Please try again.");
    error.response = { data: response };
    throw error;
  }
  return response.data;
}

export function pixelError(error) {
  const body = error?.response?.data;
  const fields = body?.data?.errors || body?.errors || {};
  return Object.values(fields).flat()[0] || body?.msg || body?.message || error?.message || "The request could not be completed. Please try again.";
}

export function upsertById(items, item) {
  return items.some((entry) => String(entry.id) === String(item.id))
    ? items.map((entry) => String(entry.id) === String(item.id) ? item : entry)
    : [...items, item];
}
